import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/learn_box.png'
import _imports_1 from '@/assets/img/learn_balloon1.svg'
import _imports_2 from '@/assets/img/learn_balloon2.svg'
import _imports_3 from '@/assets/img/learn_balloon3.svg'
import _imports_4 from '@/assets/img/learn_balloon1_sp.svg'
import _imports_5 from '@/assets/img/learn_balloon2_sp.svg'
import _imports_6 from '@/assets/img/learn_balloon3_sp.svg'
import _imports_7 from '@/assets/img/learn_hiroshima_white.png'
import _imports_8 from '@/assets/img/hiroshima_1.jpg'
import _imports_9 from '@/assets/img/hiroshima_2.jpg'
import _imports_10 from '@/assets/img/hiroshima_3.jpg'
import _imports_11 from '@/assets/img/hiroshima_4.jpg'
import _imports_12 from '@/assets/img/learn_nagasaki_white.png'
import _imports_13 from '@/assets/img/nagasaki_1.jpg'
import _imports_14 from '@/assets/img/nagasaki_2.jpg'
import _imports_15 from '@/assets/img/nagasaki_3.jpg'


const _withScopeId = n => (_pushScopeId("data-v-38f71002"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box-top" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "box-left" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "box-left_wrap" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "text1" }, [
          /*#__PURE__*/_createTextVNode("第 "),
          /*#__PURE__*/_createElementVNode("span", null, "1"),
          /*#__PURE__*/_createTextVNode(" 部")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "line" }),
        /*#__PURE__*/_createElementVNode("h2", null, "LEARN"),
        /*#__PURE__*/_createElementVNode("p", { class: "text2" }, "遠隔平和学習"),
        /*#__PURE__*/_createElementVNode("p", { class: "text3 sp-none" }, [
          /*#__PURE__*/_createElementVNode("b", null, "遠隔でもまるで同じ空間にいるようなリアルな遠隔平和学習をめざし巨大パネルを使った遠隔平和学習を実施しました。"),
          /*#__PURE__*/_createTextVNode(" 広島会場には内藤達郎氏、長崎会場には調仁美氏に講師として登壇いただき、参加者は普段目にしている街の風景やモニュメントに込められた平和への想い・設立の意図について、学習しました。 学生たちは、広島・長崎で感じ方の違いについて感想を述べ、ディスカッションを行いました。コミュニケーション枠参加者もオンラインで感想を述べました。 "),
          /*#__PURE__*/_createElementVNode("b", null, "その他、Zoomチャット機能でウェビナー参加者からもコメントが送られ、全国・世界とのオンラインコミュニケーションを実装しました。")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "box-right" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-1 sp-none",
        src: _imports_1,
        alt: "新たな平和学習"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-2 sp-none",
        src: _imports_2,
        alt: "5G通信で広島・長崎を中継"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-3 sp-none",
        src: _imports_3,
        alt: "広島・長崎の教室の様子をパネルに投影する遠隔授業"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-1 pc-none",
        src: _imports_4,
        alt: "新たな平和学習"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-2 pc-none",
        src: _imports_5,
        alt: "5G通信で広島・長崎を中継"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-3 pc-none",
        src: _imports_6,
        alt: "広島・長崎の教室の様子をパネルに投影する遠隔授業"
      })
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "text3 pc-none" }, [
      /*#__PURE__*/_createElementVNode("b", null, "遠隔でもまるで同じ空間にいるようなリアルな遠隔平和学習をめざし巨大パネルを使った遠隔平和学習を実施しました。"),
      /*#__PURE__*/_createTextVNode(" 広島会場には内藤達郎氏、長崎会場には調仁美氏に講師として登壇いただき、参加者は普段目にしている街の風景やモニュメントに込められた平和への想い・設立の意図について、学習しました。 学生たちは、広島・長崎で感じ方の違いについて感想を述べ、ディスカッションを行いました。コミュニケーション枠参加者もオンラインで感想を述べました。 "),
      /*#__PURE__*/_createElementVNode("b", null, "その他、Zoomチャット機能でウェビナー参加者からもコメントが送られ、全国・世界とのオンラインコミュニケーションを実装しました。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    id: "learn",
    class: "box-content"
  }, [
    /*#__PURE__*/_createElementVNode("h3", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "hiroshima",
        src: _imports_7,
        alt: ""
      }),
      /*#__PURE__*/_createTextVNode(" HIROSHIMA side")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid_card" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_8,
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("p", null, "「へいわ創造機構ひろしま(hope)」")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid_card" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_9,
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("p", null, "「へいわ創造機構ひろしま(hope)」")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid_card" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_10,
          alt: ""
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid_text" }, [
        /*#__PURE__*/_createElementVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" 広島講演の様子。"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" 広島の歴史や折り鶴を当時折り続けていた佐々木禎子さんのお話を広島・長崎の学生たちがお互いにコミュニケーションをとりながら学びました。 ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "box-content_wide" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_11,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" 折り鶴制作の様子。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 広島・長崎会場で、佐々木貞子さんの折り鶴と同じく薬包紙を使って折り鶴を折り、"),
        /*#__PURE__*/_createElementVNode("br", { class: "sp-none" }),
        /*#__PURE__*/_createTextVNode("全員で記念撮影を行いました。 ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "box-content" }, [
    /*#__PURE__*/_createElementVNode("h3", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "nagasaki",
        src: _imports_12,
        alt: ""
      }),
      /*#__PURE__*/_createTextVNode(" NAGASAKI side")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid_card" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_13,
          alt: ""
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid_card" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_14,
          alt: ""
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid reverse" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid_text" }, [
        /*#__PURE__*/_createElementVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" 長崎講演の様子。"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" 長崎の平和に関するモニュメントや記念碑について学生たちが学びました。"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" モニュメントの色や形に込められた想いについても、"),
          /*#__PURE__*/_createElementVNode("br", { class: "sp-none" }),
          /*#__PURE__*/_createTextVNode("巨大スクリーンを通して目で見て学ぶことができました。 ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "box-content_grid_card" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_15,
          alt: ""
        })
      ])
    ])
  ])
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, _hoisted_2))
}